export class EbsSnapshotRestoreDestination {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "awsEbs",
            "baseName": "awsEbs",
            "type": "EbsSnapshotTarget",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EbsSnapshotRestoreDestination.attributeTypeMap;
    }
    constructor() {
    }
}
